<template>
  <div class="login-form-container">
    <h1 class="login-form-card-title">Log in with Single Sign-on (SSO)</h1>
    <a-form
      ref="loginForm"
      :form="form"
      layout="vertical"
      :action="samlAuthPath"
      :style="{ marginBottom: '4px' }"
      method="POST"
      @submit.stop.prevent="handleSubmit"
    >
      <input type="hidden" name="authenticity_token" :value="csrfToken" />
      <a-form-item>
        <span slot="label">Email</span>
        <a-input
          v-decorator="[
            'email',
            { rules: [{ required: true, message: 'Enter your email' }] },
          ]"
          name="username"
          autoFocus
        />
      </a-form-item>
      <a-button type="primary" htmlType="submit">Log in with SSO</a-button>
    </a-form>
    <a-divider plain class="login-divider">or</a-divider>
    <a-button @click="redirectToNonSSOLogin">Log in with Password</a-button>
    <span v-if="showSignUpLink" class="sign-up-prompt">
      Don't have an account?
      <br />
      <a href="https://www.opslevel.com/request-a-demo" target="_blank">
        Schedule a time to meet with our team.
      </a>
    </span>
    <span
      v-if="showTidraSignUpLink"
      class="sign-up-prompt sign-up-prompt--tidra"
    >
      New to Tidra?
      <a
        href="https://tidra.ai/get-started/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Sign Up.
      </a>
    </span>
  </div>
</template>

<script>
import csrf from "@/lib/csrf.js";
import { isSelfHosted } from "@/shared/helpers.js";

export default {
  inject: {
    brand: { default: "opslevel" },
  },

  props: {
    urls: {
      type: Object,
      required: true,
      validator: (urls) => {
        return (
          typeof urls.session === "string" && typeof urls.users === "object"
        );
      },
    },
  },

  data() {
    return {
      form: this.$form.createForm(this, {
        name: "login",
      }),
    };
  },

  computed: {
    csrfToken() {
      return csrf.token;
    },
    sessionUrl() {
      return this.urls.session;
    },
    samlAuthPath() {
      return this.urls.users.saml_auth_path;
    },
    showSignUpLink() {
      return this.brand === "opslevel" && !isSelfHosted();
    },
    showTidraSignUpLink() {
      return this.brand === "tidra";
    },
  },

  methods: {
    handleSubmit() {
      this.form.validateFields(async (err) => {
        if (!err) {
          // Instead of submitting this through axios, we are doing a regular form submission here.
          // This is because Devise will return a 302 Found, and redirect us to the login page.
          // Devise also flashes a helpful message letting you know that you can expect to receive an email
          // but axios swallows that message.
          this.$refs.loginForm.$el.submit();
        }
      });
    },
    redirectToNonSSOLogin() {
      window.location.assign(this.sessionUrl);
    },
  },
};
</script>

<style scoped>
@import "login.css";
</style>
